import cn from 'classnames';
import type { ReactNode } from 'react';
import type React from 'react';

import { useCheckoutData } from './model';
import * as st from './styles.module.scss';

type Props = {
	checkoutData: any;
	slot: ReactNode;
};

export const Checkout: React.FC<Props> = ({ checkoutData, slot }) => {
	const { amount, discount, final, loadingStatus } = useCheckoutData();

	const isPartner = checkoutData.isPartner;

	return (
		<div className={st.checkout}>
			{slot}
			<div className={st.checkout__summary}>
				<div className={st.row}>
					<span>{`Товаров (${checkoutData.items.length}) на сумму:`}</span>
					<span>{`${(amount / 100).toLocaleString()}`}</span>
					<span>RUB</span>
				</div>

				<div className={cn(st.row, st.discount)}>
					<span>{isPartner ? 'Партнерская скидка:' : 'Скидка по промокоду:'} </span>
					<span>-{`${(discount / 100).toLocaleString()}`}</span>
					<span>RUB</span>
				</div>

				<div className={cn(st.pay)}>
					<span>{isPartner ? 'Итог' : 'К оплате'}:</span>
					<span>{`${(final / 100).toLocaleString()}`}</span>
					<span>RUB</span>
				</div>

				<button className={st.checkout__pay} type="submit" disabled={loadingStatus !== 'loaded'}>
					Оплатить
				</button>
			</div>
		</div>
	);
};
